import { render, staticRenderFns } from "./YearTable.vue?vue&type=template&id=09670b38&"
import script from "./YearTable.vue?vue&type=script&lang=js&"
export * from "./YearTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports